// Interpreta o subconjunto de Markdown usado nos guias de ajuda:
// títulos (#, ##, ###), parágrafos, listas (numeradas e com marcador),
// listas aninhadas por indentação, tabelas e **negrito**.
// Devolve dados simples; quem desenha na tela é o MarkdownSimples.

const REGEX_TITULO = /^(#{1,3})\s+(.*)$/;
const REGEX_LISTA_NUMERADA = /^(\s*)\d+\.\s+(.*)$/;
const REGEX_LISTA_MARCADOR = /^(\s*)-\s+(.*)$/;
const REGEX_LINHA_TABELA = /^\s*\|.*\|\s*$/;
const REGEX_SEPARADOR_TABELA = /^\s*\|[\s:|-]+\|\s*$/;

function dividirCelulas(linha) {
  return linha
    .trim()
    .replace(/^\|/, "")
    .replace(/\|$/, "")
    .split("|")
    .map((celula) => celula.trim());
}

function criarLista(ordenada) {
  return { tipo: "lista", ordenada, itens: [] };
}

export function interpretarMarkdown(texto) {
  const linhas = String(texto || "").replace(/\r\n/g, "\n").split("\n");
  let titulo = "";
  const secoes = [{ titulo: null, blocos: [] }];

  const secaoAtual = () => secoes[secoes.length - 1];
  let paragrafo = [];
  let lista = null;
  let tabela = null;

  const fecharParagrafo = () => {
    if (paragrafo.length > 0) {
      secaoAtual().blocos.push({ tipo: "paragrafo", texto: paragrafo.join(" ") });
      paragrafo = [];
    }
  };
  const fecharLista = () => {
    lista = null;
  };
  const fecharTabela = () => {
    tabela = null;
  };
  const fecharTudo = () => {
    fecharParagrafo();
    fecharLista();
    fecharTabela();
  };

  linhas.forEach((linha) => {
    if (linha.trim() === "") {
      fecharTudo();
      return;
    }

    const titulos = linha.match(REGEX_TITULO);
    if (titulos) {
      fecharTudo();
      const nivel = titulos[1].length;
      const textoTitulo = titulos[2].trim();
      if (nivel === 1) {
        titulo = textoTitulo;
      } else if (nivel === 2) {
        secoes.push({ titulo: textoTitulo, blocos: [] });
      } else {
        secaoAtual().blocos.push({ tipo: "subtitulo", texto: textoTitulo });
      }
      return;
    }

    if (REGEX_LINHA_TABELA.test(linha)) {
      fecharParagrafo();
      fecharLista();
      if (!tabela) {
        tabela = { tipo: "tabela", cabecalho: dividirCelulas(linha), linhas: [] };
        secaoAtual().blocos.push(tabela);
      } else if (!REGEX_SEPARADOR_TABELA.test(linha)) {
        tabela.linhas.push(dividirCelulas(linha));
      }
      return;
    }

    const numerado = linha.match(REGEX_LISTA_NUMERADA);
    const marcador = linha.match(REGEX_LISTA_MARCADOR);
    const itemLista = numerado || marcador;
    if (itemLista) {
      fecharParagrafo();
      fecharTabela();
      const recuo = itemLista[1].length;
      const conteudo = itemLista[2];

      if (recuo >= 2 && lista && lista.itens.length > 0) {
        lista.itens[lista.itens.length - 1].filhos.push(conteudo);
        return;
      }

      const ordenada = Boolean(numerado);
      if (!lista || lista.ordenada !== ordenada) {
        lista = criarLista(ordenada);
        secaoAtual().blocos.push(lista);
      }
      lista.itens.push({ texto: conteudo, filhos: [] });
      return;
    }

    fecharLista();
    fecharTabela();
    paragrafo.push(linha.trim());
  });

  fecharTudo();

  return {
    titulo,
    secoes: secoes.filter((secao) => secao.titulo || secao.blocos.length > 0),
  };
}

// Divide um texto em pedaços normais e em negrito (**texto**).
export function dividirNegrito(texto) {
  return String(texto)
    .split(/(\*\*[^*]+\*\*)/g)
    .filter((parte) => parte !== "")
    .map((parte) =>
      parte.startsWith("**") && parte.endsWith("**") && parte.length > 4
        ? { negrito: true, texto: parte.slice(2, -2) }
        : { negrito: false, texto: parte },
    );
}
